export default function filterPropertyDefinitions(properties, fn) {
	const filteredPropertyDefs = {};
	if (!properties) return filteredPropertyDefs;

	const keys = Object.keys(properties);
	for (let i = 0; i < keys.length; i++) {
		const k = keys[i];
		const value = properties[k];
		if (fn(value)) filteredPropertyDefs[k] = value;
	}

	return filteredPropertyDefs;
}
